import { render, staticRenderFns } from "./GoodsMemberDiscountForm.vue?vue&type=template&id=b7187d76&scoped=true&"
import script from "./GoodsMemberDiscountForm.vue?vue&type=script&lang=js&"
export * from "./GoodsMemberDiscountForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7187d76",
  null
  
)

export default component.exports